import { useEffect } from "react";
import Box from "@mui/material/Box";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { AGENCY_LINKING_TOAST_TONE } from "../../utils/agencyAccountLinking";

const TOAST_MS = 4200;

const AgencyAccountLinkingToast = ({
  message = "",
  tone = AGENCY_LINKING_TOAST_TONE.SUCCESS,
  toastKey = 0,
  onDismiss = () => {},
}) => {
  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(onDismiss, TOAST_MS);
    return () => clearTimeout(timer);
  }, [message, toastKey, onDismiss]);

  // The live region stays mounted so screen readers announce new messages.
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-atomic="true"
      sx={{
        position: "fixed",
        bottom: "calc(28px + env(safe-area-inset-bottom, 0px))",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1600,
        // left: 50% halves the shrink-to-fit width; size to the message instead.
        width: "max-content",
        maxWidth: "calc(100vw - 32px)",
        pointerEvents: "none",
      }}
    >
      {message ? (
        <Slide key={toastKey} in direction="up">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 1.75,
              py: 1,
              borderRadius: 999,
              bgcolor: "#1F2430",
              color: "#fff",
              boxShadow: "0 10px 30px rgba(17, 24, 39, 0.18)",
            }}
          >
            {tone === AGENCY_LINKING_TOAST_TONE.SUCCESS ? (
              <CheckRoundedIcon aria-hidden sx={{ fontSize: 16 }} />
            ) : null}
            <Typography
              component="span"
              sx={{ fontSize: 13.5, fontWeight: 500, lineHeight: 1.35 }}
            >
              {message}
            </Typography>
          </Box>
        </Slide>
      ) : null}
    </Box>
  );
};

export default AgencyAccountLinkingToast;
